export default "__VITE_ASSET__BIj3hHJ8__"